import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { KnowledgeBasePage } from '@/features/knowledge-base/KnowledgeBasePage';

export const Route = createFileRoute('/_protected/t/$tenantId/knowledge-base/')({
  component: KnowledgeBaseRoute,
  validateSearch: z.object({
    // .catch: a stale or unknown tab in the URL (e.g. a bookmark of a removed tab) falls back
    // to the default instead of failing route validation and erroring the whole page.
    tab: z.enum(['packages', 'graph', 'topics', 'tags']).optional().catch(undefined),
    packageId: z.string().optional(),
    topicId: z.string().optional(),
    tagId: z.string().optional(),
  }),
});

function KnowledgeBaseRoute() {
  return <KnowledgeBasePage />;
}
